export const originalList = [
  {
    id: "orig-1",
    type: "original",
    title: "打工人の周一自救指南：五分钟把自己笑醒的十个瞬间",
    excerpt:
      "周一早上最难的不是起床，而是把自己从被子里劝起来。整理了十个真实又好笑的瞬间，愿你看完能把闹钟再按掉一次。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20morning%20bedroom%20desk%20with%20alarm%20clock%20and%20warm%20sunlight%20through%20curtains%2C%20playful%20lifestyle%20illustration%20mood%2C%20editorial%20photography%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20composition&width=800&height=600&seq=orig-cover-01&orientation=landscape",
    tag: "搞笑段子",
    tags: ["搞笑段子", "职场", "日常"],
    author: "阿搞不加班",
    source: "我爱搞原创",
    publishedAt: "2026-10-13",
    views: 88210,
    content: [
      "凌晨一点，你信誓旦旦地说：明天一定早起。凌晨三点，你在被窝里刷到一只猫的视频，笑出了声。",
      "早上七点，闹钟响起。你的手比脑子快，按掉了它。八点半，你以一种人类难以理解的姿势冲进地铁。",
      "到了工位，你发现昨天写的方案打开后是一片空白——因为根本没保存。你深吸一口气，然后打开了外卖软件，决定先吃饱再说。",
      "你看，周一也没那么可怕，笑一笑，一天就过去了一半。剩下的一半，交给下午的奶茶。",
    ],
  },
  {
    id: "orig-2",
    type: "original",
    title: "用外卖盒做了个迷你手办展示柜，朋友以为我偷偷买了套家具",
    excerpt:
      "零成本改造教程：把吃完的外卖盒洗干净，剪一剪拼一拼，就能得到一个超可爱的迷你展示柜，手办、耳环、小摆件都能放。",
    cover:
      "https://readdy.ai/api/search-image?query=handmade%20miniature%20display%20shelf%20with%20tiny%20figurines%20on%20a%20warm%20wooden%20desk%2C%20creative%20diy%20craft%20scene%2C%20editorial%20photography%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20composition&width=800&height=600&seq=orig-cover-02&orientation=landscape",
    tag: "创意手工",
    tags: ["创意手工", "DIY", "零成本"],
    author: "手作小怪兽",
    source: "我爱搞原创",
    publishedAt: "2026-10-12",
    views: 64320,
    content: [
      "攒了一个月的外卖盒，扔了可惜，留着占地。直到某天我盯着它看了三秒，突然开窍——这不就是个现成的柜子骨架吗？",
      "先把盒子洗净晾干，沿折痕剪开，用双面胶把几块板子拼成小格子。再用马克笔描一圈边，质感立刻不一样了。",
      "最后放上手办和耳环，灯光一打，朋友来家里直接问我：这套迷你家具哪买的？我说垃圾桶里捡的，她不信。",
      "整个改造前后不到四十分钟，成本是零。手残党也可以闭眼冲，翻车了也就损失一个外卖盒。",
    ],
  },
  {
    id: "orig-3",
    type: "original",
    title: "那个总在地铁口卖花的老爷爷，后来怎么样了",
    excerpt:
      "三年前，我每天下班都能看到他。后来他突然消失了。今年春天，他又出现在同一个位置，只是身边多了一个人。",
    cover:
      "https://readdy.ai/api/search-image?query=charming%20little%20flower%20cart%20with%20warm%20orange%20blooms%20beside%20a%20city%20subway%20entrance%20at%20dusk%2C%20tender%20storytelling%20mood%2C%20editorial%20photography%2C%20warm%20amber%20and%20soft%20neutral%20tones%2C%20clean%20composition&width=800&height=600&seq=orig-cover-03&orientation=landscape",
    tag: "趣味故事",
    tags: ["趣味故事", "城市", "温情"],
    author: "巷口叙事",
    source: "我爱搞原创",
    publishedAt: "2026-10-11",
    views: 57640,
    content: [
      "三年前的冬天，我每天下班路过地铁口，总能看到一位推着小花车的老爷爷。他从不吆喝，只是安静地坐着，花也卖得便宜。",
      "有一阵子他突然不见了，连续几个月，那个位置空了出来。我偶尔会想起他，猜测他是不是去别的地方了。",
      "今年春天，他又回来了，还是那辆花车，只是身边多了一位老奶奶，两人一起整理花束，有说有笑。",
      "我买了一束向日葵。老爷爷笑着说：这是我老伴，我们以前分开了很多年，现在终于可以一起卖花了。那一刻，我觉得那个地铁口的春天特别暖。",
    ],
  },
  {
    id: "orig-4",
    type: "original",
    title: "把公司年会主持稿改成相声，我在台上讲了三分钟全场的反应绝了",
    excerpt:
      "年会主持人突然请假，我被临时抓去救场。情急之下把主持稿改成了相声，没想到成了今年最欢乐的三分钟。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20company%20annual%20party%20stage%20with%20festive%20golden%20lights%20and%20decorations%2C%20joyful%20celebration%20atmosphere%2C%20editorial%20photography%2C%20warm%20orange%20and%20gold%20tones%2C%20clean%20composition&width=800&height=600&seq=orig-cover-04&orientation=landscape",
    tag: "搞笑段子",
    tags: ["搞笑段子", "年会", "职场"],
    author: "临时主持小张",
    source: "我爱搞原创",
    publishedAt: "2026-10-10",
    views: 51230,
    content: [
      "年会前一小时，主持人突发状况来不了，领导在群里问谁愿意上。安静了三十秒后，我鬼使神差地回了个我可以。",
      "拿到主持稿的那一刻我傻了——整整两千字。眼看时间不够，我索性把开场白改成了相声，一人分饰两角。",
      "上台时我手心全是汗，但第一句包袱一抖，全场笑了。那一刻我突然不紧张了，后面越说越顺。",
      "三分钟结束，掌声比我预想的久。后来同事说，这是他们参加过最不无聊的一次年会。至于我，成功避免了被安排明年继续主持的命运。",
    ],
  },
  {
    id: "orig-5",
    type: "original",
    title: "旧牛仔裤别扔！剪两刀缝一缝，做出全网最潮的收纳挂袋",
    excerpt:
      "衣柜里总有一条穿旧的牛仔裤，扔了舍不得。跟着这个教程改造，十分钟就能得到一个超能装的墙面收纳挂袋。",
    cover:
      "https://readdy.ai/api/search-image?query=upcycled%20denim%20wall%20hanging%20organizer%20filled%20with%20small%20items%20on%20warm%20cream%20wall%2C%20creative%20diy%20craft%20scene%2C%20editorial%20photography%2C%20warm%20orange%20and%20neutral%20tones%2C%20clean%20composition&width=800&height=600&seq=orig-cover-05&orientation=landscape",
    tag: "创意手工",
    tags: ["创意手工", "旧物改造", "收纳"],
    author: "旧物新生记",
    source: "我爱搞原创",
    publishedAt: "2026-10-09",
    views: 43870,
    content: [
      "那条牛仔裤陪了我五年，膝盖磨破了洞，款式也过时了，但它还是很好看的牛仔布。扔了实在可惜。",
      "我把两条裤腿剪下来，翻面后沿一侧缝合，再把裤腰的部分当作挂带的加固层，一个多格收纳袋就成型了。",
      "挂在门后，可以塞遥控器、眼镜、充电线，甚至小瓶护肤品。牛仔布的硬挺让它怎么装都不塌。",
      "算下来整个过程不到十五分钟，不用缝纫机，手缝也能搞定。现在每次看到它，我都觉得自己是个隐藏的手工大佬。",
    ],
  },
  {
    id: "orig-6",
    type: "original",
    title: "我在小区楼下摆了张免费微笑合影摊，三天收集了 200 个故事",
    excerpt:
      "一块手写纸板、一台旧相机，我在楼下支起了免费合影摊。本来只想练练手，没想到收集到了两百个陌生人的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20neighborhood%20street%20corner%20with%20a%20small%20handmade%20photo%20booth%20and%20warm%20afternoon%20light%2C%20heartwarming%20community%20storytelling%20mood%2C%20editorial%20photography%2C%20warm%20amber%20and%20cream%20tones%2C%20clean%20composition&width=800&height=600&seq=orig-cover-06&orientation=landscape",
    tag: "趣味故事",
    tags: ["趣味故事", "社区", "温暖"],
    author: "楼下摄影师",
    source: "我爱搞原创",
    publishedAt: "2026-10-08",
    views: 36540,
    content: [
      "摆摊的起因很简单：我买了台二手相机，想找个理由多拍点人。手写纸板上写着八个字——免费合影，笑脸换故事。",
      "第一天只有三个人来，一位遛狗的大爷、一对刚下班的年轻夫妻，还有一个背着书包的小学生。他们留下了各自的烦恼和快乐。",
      "第二天人渐渐多了起来，有人专程带了妆，有人拉着邻居一起来。我发现，只要有人愿意认真听，每个人都有一段想讲的话。",
      "三天下来，我收集了两百个故事。相机的存储卡满了，心也满了。下周我打算换一个路口，继续摆下去。",
    ],
  },
];